import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormCategoria from './FormCategoria';

import updateCategoria from '../../../../graphql/mutations/otros/updateCategoria.graphql';
import getCategoriaPorId from '../../../../graphql/querys/otros/getCategoriaPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateCategoria, {
  name: 'updateCategoria',
})
class EditarCategoria extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
    };

    this.props.client
      .query({
        query: getCategoriaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const categoria = res.data.getCategoriaPorId;
        console.log('Respuesta exitosa!');
        console.log(categoria);

        this.setState({
          loading: false,
          categoria: categoria,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarCategoria = this.guardarCategoria.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarCategoria(categoria) {
    console.log('categoria...');
    console.log(categoria);
    this.setState(
      {
        categoria: {
          ...this.state.categoria,
          ...categoria,
        },
      },
      function() {
        let nuevaCategoria = this.state.categoria;
        delete nuevaCategoria.__typename;
        delete nuevaCategoria._id;

        this.props
          .updateCategoria({
            variables: {
              _id: this.props.match.params.id,
              nuevaCategoria: this.state.categoria,
            },
          })
          .then(res => {
            console.log('La respuesta de la actualizacion es...');
            console.log(res);

            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos de la categoria',
            });

            this.props.history.push('/admin/otros/categorias');
          })
          .catch(err => {
            console.log('Error en la actualizacion de la categoria');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevaCategoria: this.state.categoria,
            });
            Modal.error({
              title: 'Error en la actualizacion de la categoria',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Categoria</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Categoria
          </h2>
          <br />
          <div style={estiloContent}>
            <FormCategoria
              className="formularios"
              onSubmit={this.guardarCategoria}
              onAnterior={() =>
                this.props.history.push('/admin/otros/categorias')
              }
              datos={this.state.categoria}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarCategoria);
